import React, { useCallback } from 'react';

import { PrivateRoute } from '/imports/ui/components/PrivateRoute';
import type { IdeRouteParams, PartialIdeNavigation } from './routes';
import { ideLink, ideRoute } from './routes';

const Ide = React.lazy(() => import('./IdeLoader'));

const IdeRoute = ({ projectId, fileKey, snapshotId, showSolution }: IdeRouteParams) => {
  const navigate = useCallback<PartialIdeNavigation>(
    (params) => ideLink({ projectId, fileKey, snapshotId, showSolution, ...params }),
    [projectId, fileKey, snapshotId, showSolution],
  );
  return (
    <PrivateRoute>
      <Ide
        projectId={projectId}
        fileKey={fileKey}
        snapshotId={snapshotId}
        showSolution={showSolution}
        navigate={navigate}
      />
    </PrivateRoute>
  );
};

export const ideRouter = ideRoute.parser.map(IdeRoute);
